<template>
  <div>
    <div class="header">
      <span class="h_back" @click="back"></span>
      <span class="h_title ellipse">{{detail.headline}}</span>

    </div>
    <div class="h_msg">
      <div class="h_img">
        <img :src="detail.pictureId" alt="" class="h_imgbg">
      </div>
      <p class="cp_name">{{detail.name}}</p>
      <ul class="cp_base">
        <li>
          <img src="../assets/zlxq1.svg" alt="">
          <span v-if="detail.exhibitionType == 1" class="ellipse">常设</span>
          <span v-if="detail.exhibitionType == 0" class=" ellipse">{{detail.beginTime}}-{{detail.endTime}}</span>
          <!--<span v-if="detail.exhibitionType == 0 && detail.day == '已结束'" class=" ellipse">已结束</span>-->
          <!--<span v-if="detail.exhibitionType == 0 && detail.day != '已结束'" class=" ellipse">{{detail.day}}天后闭馆</span>-->
        </li>
        <li>
          <img src="../assets/zlxq2.svg" alt="">
          <span>{{detail.openTime}}</span>
        </li>
        <li class="mum_li">
          <img src="../assets/zlxq3.svg" alt="">
          <span class="cp_mum">{{detail.openAddress}}</span>
          <router-link :to="{path:'/addressMap',query: {latitude:detail.latitude,longitude:detail.longitude}}">
            <span class="mapnav">地图</span>
            <img src="static/images/cp_rightbtn.svg" alt="" class="gotomap">
          </router-link>
        </li>
        <li class="mum_li">
          <img src="../assets/zlxq4.svg" alt="">
          <span class="cp_mum">{{detail.orgName}}</span>
          <router-link :to="{path:'/mumDetail',query: {id:detail.orgId}}">
            <span class="mapnav">详情</span>
             <img src="static/images/cp_rightbtn.svg" alt="" class="gotomap">
          </router-link>
        </li>
      </ul>
      <p class="cp_indroduce">展览详情</p>
      <div class="cp_content" v-html="detail.content"></div>
    </div>
  </div>
</template>

<script>
  import { Indicator } from 'mint-ui';
  import {api} from '../global/api';
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  export default {
    name: "collection-detail",
    data(){
      return{
        id:"",
        detail:{},//详情数据
      }
    },
    mounted(){
      this.init();
    },
    methods:{
      back(){
        this.$router.go(-1);
      },

      init(){
        Indicator.open({text: '加载中...', spinnerType: 'fading-circle'});
        let that = this;
        this.id = this.$route.query.id;
        const params = {id: this.id};
        this.$http.get(api.zhanlanDetail, {params:params} ).then(response => {
          let { success,data }=response.data;
          if(success === 1){
            Indicator.close();
            this.detail = data.Spreadtrum;
          }else{
            console.log("接口异常");
          }
          }, response => {
              console.log("请求失败了");
            })
      }

    }
  }
</script>

<style scoped="">
  .header{
    width:100%;
    height: 2.25rem;
    background-color: rgba(196, 77, 65, 1);
    position: fixed;
    top: 0;
    z-index: 100;
  }
  .header span{
    display: block;
  }
   .h_back{
    background: url("../../static/images/cp_backbtn.svg") center no-repeat;
    background-size: 100% 100%;
    width: .55rem;
    height: 1rem;
    position: absolute;
    left: .75rem;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  .h_title{
    height:  2.25rem;
    line-height:  2.25rem;
    color: rgba(255, 255, 255, 1);
    font-size: 0.8rem;
    text-align: center;
    font-family: PingFang-SC-Bold;
    width: 14rem;
    margin: 0 auto;
  }

  .h_msg{
    width: 17.25rem;
    padding: 1rem .75rem;
    margin-top: 2.25rem;
  }
  .h_img{
    position: relative;
    text-align: center;
  }
  .h_imgbg{
    width: 17.25rem;
    height: 12.9rem;
    border-radius: 0.5rem;
    display: block;
  }
  .recorder{
    position: absolute;
    right: .6rem;
    top: .45rem;
    width: 2.1rem;
    height: 2.1rem;
  }
  .cp_name{
    width: 100%;
    height: 0.7rem;
    line-height: 0.7rem;
    color: rgba(196, 77, 65, 1);
    font-size: 0.8rem;
    text-align: left;
    font-family: PingFang-SC-Bold;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    margin-top: 1rem;
    margin-bottom: .5rem;
  }
  .cp_base:after{
    content: ".";
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
  .cp_base li{
    width: 16rem;
    height: .7rem;
    border-radius: 0.4rem;
    background-color: rgba(241, 241, 242, 1);
    margin-bottom: .5rem;
    padding: .6rem;
  }
  .cp_base img{
    display: inline-block;
    width: .8rem;
    height: .8rem;
    padding-bottom: .2rem;
  }
  .cp_base span{
    width: 12rem;
    height:.8rem;
    line-height:.9rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: left;
    vertical-align: top;
    font-family: PingFang-SC-Regular;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    display: inline-block;
    margin-left: .25rem;
  }
  .gotomap{
    width: .34rem;
    height: .6rem;
    position: absolute;
    right:.65rem;
    top: 0;
    bottom:0;
    margin: auto;
    padding-bottom: 0!important;
  }
  .mapnav{
    position: absolute;
    right:1.5rem;
    top: 0;
    bottom:0;
    margin: auto;
    width: 1.2rem;
    text-align: right!important;
    height: .8rem;
  }
  .mum_li{
    position: relative;
  }
  .cp_indroduce{
    height: 0.8rem;
    line-height: 0.8rem;
    color: rgba(196, 77, 65, 1);
    font-size: 0.8rem;
    text-align: left;
    font-family: PingFang-SC-Bold;
    margin-top: .5rem;
    margin-bottom: .75rem;
  }
  .cp_content{
    width: 100%;
    line-height: 1.2rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: justify;
    font-family: PingFang-SC-Regular;
  }



</style>



// WEBPACK FOOTER //
// src/view/zhanlanDetail.vue